import { render } from "./ProcenaKandidataUserAdmin.vue?vue&type=template&id=1ba4a845&lang=html"
import script from "./ProcenaKandidataUserAdmin.vue?vue&type=script&lang=js"
export * from "./ProcenaKandidataUserAdmin.vue?vue&type=script&lang=js"

import "./ProcenaKandidataUserAdmin.vue?vue&type=style&index=0&id=1ba4a845&lang=css"
script.render = render

export default script